import eventosRotas from './eventos/rotas.js';
import contasEventosRotas from './contasEventos/rotas.js';

const routes = {
    path: 'checkins',
    name: 'Checkins',
    component: () => import('./Checkins.vue'),
    children: [
        eventosRotas,
        contasEventosRotas,
        {
            path: 'landingpages',
            name: 'Checkins_LandingPages',
            component: () => import('@/app/checkins/eventos/ListarPaginasEvento.vue'),
            meta: {
                rules: ['CHECKINS-EVENTOS-LP', 'CHECKINS-EVENTOS-LP-02', 'CHECKINS-EVENTOS-LP-00', 'CHECKINS-EVENTOS-LP-01'],
            },
        },
    ],
    meta: {
        rules: [...eventosRotas.meta.rules, ...contasEventosRotas.meta.rules],
    },
};

export default routes;
